import styled from 'styled-components';

export const FormCheckbox = styled.div<{color: string}>`
  margin: 20px 10px 32px 10px;
  text-align: initial;
  width: 100%;

  // Sobrescrevendo classes do antd para radio e checkbox
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner,
  .ant-checkbox-input:focus+.ant-checkbox-inner,
  .ant-checkbox-checked::after {
    border-color: ${(props) => props.color};
    border-radius: 50%;
  }
  
  .ant-checkbox-inner{
    border-radius: 50%;
    border-color: ${({theme}) => theme.colors.placeholder}
  }
  
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: ${({color}) => color};
    border-color: ${({color}) => color};
    border-radius: 50%;
  }

  .ant-radio-wrapper:hover .ant-radio-inner,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus+.ant-radio-inner,
  .ant-radio-checked::after {
    border-color: ${(props) => props.color};
  }
  
  .ant-radio-inner{
    border-color: ${({theme}) => theme.colors.placeholder}
  }
  
  .ant-radio-checked .ant-radio-inner {
    border-color: ${({color}) => color};
  }

  .ant-radio-inner::after {
    background-color: ${({color}) => color};
  }
`

export const FormTerms = styled.label`
  display: flex;
  width: 100%;
  align-items: center;
`

export const FormTermsText = styled.span`
  font-size: 13px;
  font-weight: 400;
  margin-left: 12px;
  line-height: 1.1rem;
` 